module.exports = __webpack_public_path__ + "static/media/instagram_new.3c88383f.svg";